import script from "./PUR03_037RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR03_037RPT.vue?vue&type=script&setup=true&lang=js"

import "./PUR03_037RPT.vue?vue&type=style&index=0&id=61509fe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61509fe6"]])

export default __exports__